module.exports = __webpack_public_path__ + "static/teaser-521bfeec61bf7284e98e9df84a7eb007.webm";